<template>
    <div :class="['langMenu',isMenuOpen ? 'langOpen' : '']" id="langmenu1">
        <ul>
            <li v-for="(lang,index) in siteLanguages" :key="lang.lc">
                <a :style="getStyleIndexAdd(index,1)" 
                    :href="getLangLink(lang)" 
                    :class="[siteLang == lang.lc ? 'active' : '']">
                    {{lang.name}}
                </a>        
            </li>
        </ul>

    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { splitLines } from "@/utils";

export default {
    name: "menu",
    props: {isMenuOpen: Boolean},
    data()
    {
        return {
            itemx:[]
          }
    },
    methods:
    {
      getLangLink(lang){
        return "/"+lang.lc;
      },
      getStyleIndexAdd(index,add)
      {
        let stIndex = index+add;
        return "--index:"+stIndex;
      },
      getStyleIndex(index){
        return "--index:"+index;
      }
    },
    computed:{
      ...mapState(["siteData","siteDataReady","siteLang"]),
        siteLanguages()
        {
            return this.siteData.LANGAUGES;
        }

    }
};

</script>


<style>
  .langMenu
  {
      position: fixed;
      top: 70px;
      right: 0px;
      width: 250px;
      height: 250px;
      overflow: hidden;
      background-color: #0b6bac;
      /* background-color: #2f6079; */
      /* var(--text-blue)*/
      z-index: 11;
      display: grid;
      align-items: center;
      text-align: left;
      opacity: 1;
      clip-path: inset(0px 0px 0% 100%);
      transition: all 0.6s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      pointer-events: none;
      padding: 0px 100px;
  }
  .langMenu.langOpen
  {
      pointer-events: all;opacity: 1;clip-path: inset(0px 0px 0px 0px);
  }
  .langMenu ul
  {
    list-style: none;
    padding:0px;
  }
  .langMenu ul li
  {
    cursor: pointer;
    line-height: 40px;
    letter-spacing: 0px;
    overflow: hidden;    
    text-align: left;
  }
  .langMenu ul li:hover a
  {
    opacity: 1;
  }

  .langMenu ul li a{color:#fff !important;}  
  .langMenu ul li a
  {
    cursor: pointer !important;
    font-size: 18px;
    line-height: 40px;
    font-weight: 300 !important;
    letter-spacing: 0px !important;
    position: relative;
    top: 30px;
    transition-property: top;
    transition-duration: 0.5s;
    transition-delay: calc(0.1s + (0.05s * var(--index))) !important;
    transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  .langMenu.langOpen ul li a
  {
      top: 0px;
  }
  .langMenu ul li a.active
    {
        opacity: 1;
    }



  

  @media (hover: hover) {
  .langMenu ul li a
  {
    opacity: 0.8;
  }

  }

  @media (max-width: 850px) { 
  .langMenu
  {
      width: 180px;
      height: 300px;
      overflow: hidden;
      padding: 70px 50px 0px 50px;
      display: block;
  }    
  }  
</style>